"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurriculumName = void 0;
exports.getCurriculumNames = getCurriculumNames;
exports.getCurriculumNameFromCurriculum = getCurriculumNameFromCurriculum;
var CurriculumName;
(function (CurriculumName) {
    CurriculumName["EurekaMath"] = "Eureka Math";
    CurriculumName["EurekaMathBBL"] = "Eureka Math Blue Bonnet";
    CurriculumName["EurekaMath2"] = "Eureka Math 2";
    CurriculumName["EurekaMath2CA"] = "Eureka Math 2 CA";
    CurriculumName["EurekaMath2CARev"] = "Eureka Math 2 CA Revision";
    CurriculumName["EurekaMath2LA"] = "Eureka Math 2 LA";
    CurriculumName["EurekaMath2UTE"] = "Eureka Math 2 UTE";
    CurriculumName["EurekaMath2FL"] = "Eureka Math 2 FL";
    CurriculumName["EurekaMath2NY"] = "Eureka Math 2 NY";
    CurriculumName["EurekaMathTX"] = "Eureka Math TX";
    CurriculumName["EurekaMath2TN"] = "Eureka Math 2 TN";
    CurriculumName["WitAndWisdom"] = "Wit & Wisdom";
    CurriculumName["PhDScience"] = "Phd Science";
    CurriculumName["PhDScienceTX"] = "Phd Science TX";
    CurriculumName["PhDScienceCA"] = "Phd Science CA";
    CurriculumName["PhDScienceNAT"] = "Phd Science NAT";
    CurriculumName["PhDScienceNAT25"] = "Phd Science NAT 25";
    CurriculumName["PhDPilot"] = "Phd Science Pilot";
    CurriculumName["PhdGMAA"] = "Phd Science GMAA";
    CurriculumName["Geodes"] = "Geodes";
    CurriculumName["WitAndWisdomDTE"] = "Wit & Wisdom Digital Teacher Edition";
    CurriculumName["WitAndWisdomFL"] = "Wit & Wisdom Florida Digital Teacher Edition";
    CurriculumName["WitAndWisdomOR"] = "Wit & Wisdom Oregon Digital Teacher Edition";
    CurriculumName["ArtsAndLetters"] = "Arts & Letters";
})(CurriculumName || (exports.CurriculumName = CurriculumName = {}));
function getCurriculumNames() {
    return Object.values(CurriculumName);
}
function getCurriculumNameFromCurriculum(curriculum) {
    return getCurriculumNames().find(function (type) { return type === curriculum; });
}
